<template>
  <div>
    <PageTitle
      title="Document Upload View"
      :backBtn="true"
      :editRoute="'/document-uploads/edit/' + DocumentUploadList.id"
      :permission="'Document Upload Edit'"
    />
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xs="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title">
              <v-icon color="blue" small>mdi-file</v-icon>
              <span class="ml-3">Document Upload</span>
            </v-card-title>
            <v-container fluid class="container docUploadCard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-row class="pt-0">
                    <v-col
                      cols="12"
                      sm="12"
                      md="4"
                      lg="4"
                      class="pr-5 mt-3 pb-1 name"
                    >
                      <v-icon>mdi-sale</v-icon>
                      {{ DocumentUploadList.name }}
                    </v-col>
                    <v-col
                      cols="1"
                      sm="12"
                      md="1"
                      lg="1"
                      class="shoptext pr-5 pt-0 mt-7"
                    >
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0 mt-5"
                    >
                      <v-row class="subtextlable"> Date </v-row>
                      <v-row>
                        <v-icon small>mdi-calendar</v-icon>
                        {{ DocumentUploadList.date | formatDate }}
                      </v-row>
                    </v-col>
                    <v-col
                      cols="1"
                      sm="12"
                      md="1"
                      lg="1"
                      class="shoptext pr-5 pt-0 mt-7"
                    >
                      <v-divider></v-divider>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      class="shoptext pr-5 pt-0 mt-5"
                    >
                      <v-row class="subtextlable"> Document Type </v-row>
                      <v-row>
                        <v-icon small>mdi-calendar</v-icon>
                        {{ DocumentType.name }}
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="5"
                      lg="5"
                      class="shoptext pl-5 pt-0 mt-5"
                    >
                      <v-row class="subtextlable"> Description </v-row>
                      <v-row class="pl-1 mt-1">
                        {{
                          DocumentUploadList.description
                            ? DocumentUploadList.description
                            : '----'
                        }}
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="lighten-12">
            <v-card-title>Files</v-card-title>
            <v-container fluid class="container docUploadCard">
              <v-row>
                <v-col cols="12" sm="12" lg="12">
                  <FileUpload
                    :multiple="true"
                    size="2048"
                    icon="mdi-upload"
                    autoupload="true"
                    :url="
                      'document/upload/DOCUMENTUPLOAD/' + this.$route.params.id
                    "
                    :showDocumentView="true"
                    :documentsUrl="
                      'document/DOCUMENTUPLOAD/' + this.$route.params.id
                    "
                    downloadUrl="document/:id/download"
                    removeUrl="document/:id"
                  ></FileUpload>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FileUpload from '@/components/base/FileUpload';
import DocumentView from '@/components/base/DocumentView';
import axios from '@/plugins/axios';
import 'jspdf-autotable';
import VueDocPreview from 'vue-doc-preview';
import _ from 'lodash';

export default {
  data: () => ({
    DocumentUploadList: [],
    DocumentType: [],
    documentuploadId: '',
  }),
  methods: {
    GetDocumentUpload() {
      this.documentuploadId = this.$route.params.id;
      this.$store
        .dispatch('DocumentUpload/GetDocumentUpload', this.documentuploadId)
        .then(async (res) => {
          this.DocumentUploadList = res.data;
          axios
            .get(`document-types/${this.DocumentUploadList.type_id}`)
            .then((resp) => {
              this.DocumentType = resp.data;
            });
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data;
        });
    },

    DocumentView() {
      var fileId = this.$route.params.id;
      var documentType = 'DOCUMENTUPLOAD';
      this.$store
        .dispatch('DocumentView', {
          fileId,
          documentType,
        })
        .then((resp) => {});
    },
  },

  components: {
    FileUpload,
    DocumentView,
    VueDocPreview,
  },
  created() {
    this.DocumentView();
    this.GetDocumentUpload();
  },
  computed: {},
};
</script>
<style scoped>
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
}
.docUploadCard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.name {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.totalText {
  font-family: Roboto;
  font-size: 16px;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */
  text-align: center;
  color: #000000;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
</style>
